import React from 'react'
import ReactDOM from 'react-dom'
import App from './App'

ReactDOM.render(
    <React.StrictMode>
        {/* <h3>Hello React</h3> */}
        <App />
    </React.StrictMode>,document.getElementById('root')
)
